import * as React from "react";

export const SvgArrowTop = (props) => (
	<svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M10 5.228c.307 0 .614.117.849.352l7.37 7.37a1.2 1.2 0 0 1-1.697 1.699L10 8.126l-6.522 6.522A1.2 1.2 0 0 1 1.78 12.95l7.371-7.37c.235-.235.542-.352.849-.352Z"
			fill={props.color ?? "#A8A8A8"}
		/>
	</svg>
);
